module.exports = __webpack_public_path__ + "static/back-c67eac7a5c00eb3bb7257fe250805bf8.jpg";